export const roles = [
    'super-admin',
    'user',
];